export const MANAGE_WORKFLOW_ACTION_SUBJECT_ID = 'manageWorkflowButton';
export const MANAGE_WORK_TYPES_ACTION_SUBJECT_ID = 'manageIssueTypesButton';
export type ManageFieldActionSubjectId =
	| typeof MANAGE_WORKFLOW_ACTION_SUBJECT_ID
	| typeof MANAGE_WORK_TYPES_ACTION_SUBJECT_ID;
